import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Scroll restoration for SPA route transitions.
 *
 * - Scrolls to top on pathname changes (typical Link clicks)
 * - If a hash is present, let the browser handle anchor navigation
 */
export function ScrollToTop() {
  const location = useLocation()

  useEffect(() => {
    if (location.hash) return
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [location.pathname]) // intentionally ignore search to avoid jumping on filter tweaks

  return null
}

